export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { label: '精选推荐', href: '#cards' },
    { label: '热度榜单', href: '#ranking' },
    { label: '精彩视频', href: '#media' },
    { label: '最新动态', href: '#updates' },
    { label: '热门话题', href: '#topics' },
    { label: '常见问题', href: '#faq' },
  ];

  return (
    <footer id="footer" className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[320px] flex-shrink-0">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
              className="flex items-center gap-2 mb-4 cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-white text-xl"></i>
              </div>
              <span className="font-heading font-bold text-background-50 text-lg">
                6080新视觉影视
              </span>
            </a>
            <p className="text-sm text-background-300 leading-relaxed mb-5">
              6080新视觉影视免费在线观看平台，提供免费电影、电视剧全集，无需付费，在线免费看片，海量高清影视资源，每日同步更新热门剧集，免费影视平台等你来追。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-lg"></i>
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 flex-1">
            <div>
              <h4 className="font-heading font-semibold text-background-100 text-sm mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {quickLinks.slice(0, 3).map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-background-100 text-sm mb-4">更多链接</h4>
              <ul className="space-y-2.5">
                {quickLinks.slice(3).map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-background-100 text-sm mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500 leading-relaxed">
                期待与更多优质平台携手合作，共同为用户提供更丰富的观影体验。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 6080新视觉影视 版权所有
          </p>
          <p className="text-xs text-background-600">
            本站资源均来自网络，仅供交流学习使用
          </p>
        </div>
      </div>
    </footer>
  );
}